// Shared fee-tracker presentation bits. Lives here rather than in one of the
// pages because both the admin report/detail view and the student view render
// the same status vocabulary. Record-keeping only — there is no gateway here.
import { Badge } from "@/components/ui/badge";

// Matches the derived installment / batch-row statuses in backend/server.py
// (fee_structure_totals / batch_fee_report). "no_structure" only appears on
// the batch report row, never on an installment.
export const FEE_STATUS_STYLES = {
    paid: "bg-[#16A34A] hover:bg-[#16A34A] text-white",
    pending: "bg-[#FFA81B] hover:bg-[#FFA81B] text-white",
    overdue: "bg-[#E11D48] hover:bg-[#E11D48] text-white",
    waived: "bg-muted text-muted-foreground hover:bg-muted",
    no_structure: "bg-muted text-muted-foreground hover:bg-muted",
};

export function FeeStatusBadge({ status }) {
    return (
        <Badge className={`text-[10px] uppercase tracking-wider ${FEE_STATUS_STYLES[status] || ""}`}>
            {(status || "").replace("_", " ")}
        </Badge>
    );
}

/** ₹ with Indian digit grouping (e.g. ₹1,00,000.00). Falls back gracefully if
 *  the value is missing/NaN — fee amounts are always in INR (see BACKLOG). */
export function formatINR(amount) {
    const n = Number(amount);
    if (Number.isNaN(n)) return "₹0";
    return `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const PAYMENT_METHOD_LABELS = {
    cash: "Cash", upi: "UPI", bank: "Bank transfer", cheque: "Cheque", other: "Other",
};
